export enum ApiMethods {
    AccountsGetMe = "Accounts.GetMe",
    AuthCheckAuth = "Auth.CheckAuth",
    AuthRefreshTokenPair = "Auth.RefreshTokenPair",
    AuthSignin = "Auth.Signin",
    AuthSignup = "Auth.Signup",
    MenuCategoriesCreateMenuCategory = "MenuCategories.CreateMenuCategory",
    MenuCategoriesDeleteMenuCategory = "MenuCategories.DeleteMenuCategory",
    MenuCategoriesGetMenuCategories = "MenuCategories.GetMenuCategories",
    MenuCategoriesUpdateMenuCategory = "MenuCategories.UpdateMenuCategory",
    MenuItemsCreateMenuItem = "MenuItems.CreateMenuItem",
    MenuItemsDeleteMenuItem = "MenuItems.DeleteMenuItem",
    MenuItemsGetMenuItems = "MenuItems.GetMenuItems",
    MenuItemsUpdateMenuItem = "MenuItems.UpdateMenuItem",
    MenusCreateMenu = "Menus.CreateMenu",
    MenusDeleteMenu = "Menus.DeleteMenu",
    MenusGetMenu = "Menus.GetMenu",
    MenusGetMenus = "Menus.GetMenus",
    MenusUpdateMenu = "Menus.UpdateMenu",
    ProductsCreateReadyProduct = "Products.CreateReadyProduct",
    ProductsCreateRecipeProduct = "Products.CreateRecipeProduct",
    ProductsDeleteProduct = "Products.DeleteProduct",
    ProductsGetProducts = "Products.GetProducts",
    ProductsSearchProducts = "Products.SearchProducts",
    ProductsUpdateReadyProduct = "Products.UpdateReadyProduct",
    ProductsUpdateRecipeProduct = "Products.UpdateRecipeProduct",
    SuppliersCreateSupplier = "Suppliers.CreateSupplier",
    SuppliersGetSuppliers = "Suppliers.GetSuppliers",
    SuppliersSearchSuppliers = "Suppliers.SearchSuppliers",
    SuppliersUpdateSupplier = "Suppliers.UpdateSupplier",
    WarehousesAddProductLoss = "Warehouses.AddProductLoss",
    WarehousesAddProductSupply = "Warehouses.AddProductSupply",
    WarehousesAddProductTransfer = "Warehouses.AddProductTransfer",
    WarehousesCreateWarehouse = "Warehouses.CreateWarehouse",
    WarehousesGetProductTransfers = "Warehouses.GetProductTransfers",
    WarehousesGetWarehouses = "Warehouses.GetWarehouses",
    WarehousesUpdateWarehouse = "Warehouses.UpdateWarehouse",
}


// export const API_URL = "http://localhost:5004"; //http://178.79.186.93:18221";
export const API_URL = ""; //http://178.79.186.93:18221";

// export const API_URL_EXECUTE_ENDPOINT = "http://localhost:5004/api/execute/"; //http://178.79.186.93:18221/api/execute/";
export const API_URL_EXECUTE_ENDPOINT = "/api/execute/"; //http://178.79.186.93:18221/api/execute/";
// export const API_URL_EXECUTE_ENDPOINT = "https://0ddae966f50c.ngrok.io/api/execute/"; //http://178.79.186.93:18221/api/execute/";
